import React, { useEffect } from 'react'
import { MenuContainer, ContentContainer, ContentBodyContainer, DateText, TextContainer, BodyText, MultilineBodyText, Button, ProductAnnouncementContainer, MediaContainer } from '../style'
import { IngressLink, Text, MultilineContentWrapper } from '../../style'
import { useFeatureContext } from '../../../../contexts/FeatureContext'
import { WidgetTypes } from '../../../../common/constants'
import { taktId } from '../../../../utils/takt'
import { MenuButton } from './MenuButton'

export const FeatureModalContent = (): JSX.Element => {
  const { featureData, featureKeys, featureId, featureLabels, setFeatureIdEvent } = useFeatureContext()
  useEffect(() => {
    if (!featureKeys.includes(featureId)) setFeatureIdEvent(featureKeys[0])
  }, [featureId])
  const featureContent = featureData[featureId]
  const dataTaktId = taktId(WidgetTypes.WhatsNewCenterItem, featureId)
  return (
    <>
      <MenuContainer>
        <DateText fontSize="small">{featureLabels?.lastDays}</DateText>
        {featureKeys.map((key) => (
          <MenuButton key={key} menuId={key} />
        ))}
        <ProductAnnouncementContainer>
          <IngressLink external={true} size="base" href="https://advertising.amazon.com/resources/whats-new" target="_blank" data-takt-id={taktId(WidgetTypes.WhatsNewCenterItem, 'announce-link')}>
            {featureLabels?.fitNoDataLinkLabel}
          </IngressLink>
        </ProductAnnouncementContainer>
      </MenuContainer>
      <ContentContainer>
        <Text fontSize="large">{featureContent?.title}</Text>
        <ContentBodyContainer>
          <TextContainer>
            {featureContent?.multiLineContent && (
              <MultilineContentWrapper>
                {featureContent.multiLineContent.map((content, index) => (
                  <MultilineBodyText key={index}>{content}</MultilineBodyText>
                ))}
              </MultilineContentWrapper>
            )}
            {!featureContent?.multiLineContent && featureContent?.content && <BodyText>{featureContent?.content}</BodyText>}
            {featureContent?.externalLink && (
              <IngressLink href={featureContent?.externalLink?.link?.link} external={true} size="base" target="_blank" data-takt-id={`${dataTaktId}_link`}>
                {featureContent?.externalLink?.link?.label}
              </IngressLink>
            )}
            {featureContent?.internalLink && (
              <Button onClick={() => window.open(featureContent?.internalLink?.link?.link, '_self')} data-takt-id={`${dataTaktId}_cta-button`}>
                {featureContent?.internalLink?.link?.label}
              </Button>
            )}
          </TextContainer>
          {featureContent?.embeddedImage && <MediaContainer alt={featureContent?.embeddedImage?.altText} src={featureContent?.embeddedImage?.link} />}
        </ContentBodyContainer>
      </ContentContainer>
    </>
  )
}
